module.exports = __webpack_public_path__ + "img/user-mail.e24e33d2.svg";